import {CustomRoleFeatureKeys} from 'src/security/customRoleFeatureKeys';

/**
 * Reasignar tareas: permiso legacy `tareaReassign` (rol `reasignadorDeTareas` / `admin`) o feature `taskReassign` en rol custom.
 * Alineado con stem-web-backend `canReassignTasks` y planiwise-app `showReassign`.
 */
const REASSIGN_FIXED_ROLES = ['admin', 'reasignadorDeTareas'] as const;

export function canUseTaskReassignForUi(
  hasPermissionTareaReassign: boolean,
  featureKeys: readonly string[],
  tenantAccessContextLoadStatus: 'loaded' | 'failed' | null | undefined,
  roles?: readonly string[],
): boolean {
  if (hasPermissionTareaReassign) {
    return true;
  }
  if (roles?.some((r) => (REASSIGN_FIXED_ROLES as readonly string[]).includes(r))) {
    return true;
  }
  if (tenantAccessContextLoadStatus === 'failed') {
    return false;
  }
  return featureKeys.includes(CustomRoleFeatureKeys.taskReassign);
}
